import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { sendAnnualReport } from '../utils/sendAnnualReport'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'

export const useSendAnnualReportMutation = () => {
  return useMutation({
    mutationFn: ({ memberId, year }: { memberId: string; year: number }) =>
      sendAnnualReport({ memberId, year }),
    onSuccess: ({ message }) => {
      toast.success(message || 'Annual report sent successfully.')
    },
    onError: (error: ApiError) => {
      notifyRequestError(
        error,
        'An error occurred while sending annual report email.',
      )
    },
  })
}
